<script setup lang="ts">
import Select from '@mobile/components/Select/Select.vue'
import { SelectOption } from '@mobile/components/Select/types/SelectOption'

import { useEventInjections } from '../../../../Shared/RelationDependencies/useEventInjections'
import { useSportOptions } from '../../../Sports/composables/useSportOptions'
import { useEventRelationSettings } from '../../../Sports/useEventRelationSettings'

// composables
const eventInjections = useEventInjections()
const sportOptionsComposable = useSportOptions(eventInjections.sport)
const { incidentsPerPage } = useEventRelationSettings(
  eventInjections,
  sportOptionsComposable,
)

// data
const options: SelectOption[] = [
  { name: '10 incidents', value: 10 },
  { name: '20 incidents', value: 20 },
  { name: '30 incidents', value: 30 },
  { name: '40 incidents', value: 40 },
  { name: '50 incidents', value: 50 },
]
</script>

<template>
  <div class="flex flex-col">
    <span class="pb-1 text-xs">Per page</span>
    <Select
      v-model="incidentsPerPage"
      label="name"
      mode="single"
      :options
    />
  </div>
</template>
